import React, { useState } from "react"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import Cookies from "universal-cookie"
import { userInfo, userRole } from "utils"

import customerImage from "../../../../assets/images/avatar/avatar-customer.png"
import assistantImage from "../../../../assets/images/avatar/avatar-getech.jpg"

const MessageDropdown = ({ history }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { role } = userInfo()
  const cookies = new Cookies()
  const unreads = cookies.get("unreads")
  const unReadMessages = cookies.get("unreadMessages")
  const displayImg =
    role === userRole.CUSTOMER || role === userRole.CUSTOMER_PURCHASER
      ? assistantImage
      : customerImage

  return (
    <Dropdown nav inNavbar isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle nav caret>
        <i className="mdi mdi-message" />
        {unreads && unreads > 0 && (
          <div className="notify">
            {" "}
            <span className="heartbit" /> <span className="point" />{" "}
          </div>
        )}
      </DropdownToggle>
      <DropdownMenu right className="mailbox">
        <div className="p-4 text-dark border-bottom">
          <h6 className="mb-0 font-medium">
            {unreads ? `您有 ${unreads} 則新訊息` : "您沒有新訊息"}
          </h6>
        </div>
        <div
          className="message-center notifications"
          style={{ maxHeight: "350px" }}
        >
          {/* <!-- Message --> */}
          {unReadMessages?.length > 0 && (
            <PerfectScrollbar>
              {unReadMessages.map((message, index) => (
                <div
                  className="message-item"
                  key={index}
                  onClick={() => {
                    history.push(
                      `/message/${message.chatRoomId}/${message.name}`
                    )
                    setIsOpen(!isOpen)
                  }}
                >
                  <img
                    src={displayImg}
                    alt="user"
                    className="rounded-circle"
                    style={{ width: "50px", height: "50px" }}
                  />
                  <div className="mail-contnet">
                    <h5 className="message-title">{message.name}</h5>
                    <span className="mail-desc">{message.content}</span>
                    <span className="time">{message.createdAt}</span>
                  </div>
                </div>
              ))}
            </PerfectScrollbar>
          )}
        </div>
        <a
          className="nav-link text-center mb-1 text-muted unselectable pointer"
          onClick={() => {
            history.push("/message")
            setIsOpen(!isOpen)
          }}
        >
          <strong>查看所有訊息</strong> <i className="fa fa-angle-right" />
        </a>
      </DropdownMenu>
    </Dropdown>
  )
}

export default MessageDropdown
